import script from "./WCProductCardBadgesModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCProductCardBadgesModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCProductCardBadgesModern.vue?vue&type=style&index=0&id=1d605dd0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d605dd0"]])

export default __exports__